export default __webpack_public_path__ + "static/media/wallet.f169a7a4.svg";